module.exports = __webpack_public_path__ + "static/ff-saleslanding-image-header-backdrop-landon-parenteau-EEuDMqRYbx0-unsplash.4c554fa7.jpg";